export const appRoutes = {
  settings: '/',
  changeTransferability: '/settings/change-transferability',
  manageTokenAllowList: '/settings/manage-allowlist'
};
